import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { mergeClasses, removeBodyOverflowHidden } from "../../core/utils";
import Scrim from "../Scrim/Scrim";
import tgb from "../../assets/logo/zeropa-on-transparent.png";
import { motion } from "framer-motion";
import { Avatar } from "@material-tailwind/react";

import "./Hamburger.css";
import { API_URL } from "../../core/constants";
import axios from "axios";

const Hamburger = ({
  styles = {},
  classes = [],
  isOpen = false,
  children,
  session,
  onSignOut,
}) => {
  const _styles = Object.assign({}, styles);
  const [open, setOpen] = useState(isOpen);
  const [apiVersion, setApiVersion] = useState(null);

  useEffect(() => {
    const fetchApiVersion = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/version`);
        setApiVersion(response.data.version);
      } catch (error) {
        setApiVersion("unavailable");
      }
    };
    fetchApiVersion();
  }, []);

  const renderSessionInfo = () => {
    return (
      <>
        <p className="text-xs text-slate-500">
          Session ID: {session?.session.id}
        </p>
      </>
    );
  };

  useEffect(() => {
    const handleKeyPress = (e) => {
      if ((open && e.key === "Escape") || e.code === "Escape") {
        setOpen(false);
      }
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    removeBodyOverflowHidden();

    if (open) {
      window.addEventListener("keydown", handleKeyPress);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [open]);

  const handleClick = (e) => {
    setOpen(!open);
  };

  const exitHandler = (url, timeout = 250) => {
    handleClick();
    setTimeout(() => {
      window.location.href = url;
    }, timeout);
  };

  const EXIT_DELAY = 300;

  return (
    <>
      <div>
        <Scrim active={open} handleClick={handleClick} />
        <div
          style={_styles}
          className={classNames(mergeClasses(["hamburger"], classes))}
          onClick={handleClick}
        >
          <div className="hamburger__button-container">
            <button
              className={classNames([open ? "opened" : ""])}
              aria-label="Main Menu"
              aria-expanded={open}
            >
              <svg width="50" height="50" viewBox="0 0 100 100">
                <path
                  className="line line1"
                  d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058"
                />
                <path className="line line2" d="M 20,50 H 80" />
                <path
                  className="line line3"
                  d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942"
                />
              </svg>
            </button>
          </div>
        </div>

        <div
          className={classNames([
            "hamburger__shade max-w-[320px] md:max-w-[500px]",
            open ? "opened" : "",
          ])}
        >
          <div className="hamburger__shade-inner"> </div>
          <div className="hamburger__menu-container">
            <div>
              <div className="relative w-[96%] -top-40px] flex flex-col items-center justify-center">
                <img
                  src={tgb}
                  alt="ZeroPA"
                  title="ZeroPA"
                  className="m-0 w-[70%] md:w-[300px]"
                />

                <ul className="mt-2 mb-2 w-[96%]">
                  <li className="px-8 py-1 md:py-2">
                    <span
                      className="text-pink-200 text-lg md:text-2xl hover:cursor-pointer hover:text-pink-500"
                      onClick={() =>
                        exitHandler("/jupiter/dashboard", EXIT_DELAY)
                      }
                    >
                      🏡 Dashboard
                    </span>
                  </li>
                  <li className="px-8 py-1 md:py-2">
                    <span
                      className="text-pink-200 text-lg md:text-2xl hover:cursor-pointer hover:text-pink-500"
                      onClick={() =>
                        exitHandler("/jupiter/dashboard", EXIT_DELAY)
                      }
                    >
                      💸 Applications
                    </span>
                  </li>
                  <li className="px-8 py-1 md:py-2">
                    <span
                      className="text-pink-200 text-lg md:text-2xl hover:cursor-pointer hover:text-pink-500"
                      onClick={() => exitHandler("/jupiter/users", EXIT_DELAY)}
                    >
                      👨‍👩‍👧‍👦 <span className="pl-1">Users</span>
                    </span>
                  </li>

                  <li className="px-8 py-1 md:py-2">
                    <span
                      className="text-pink-200 text-lg md:text-2xl hover:cursor-pointer hover:text-pink-500"
                      onClick={onSignOut}
                    >
                      👋 Signout
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="w-[70%] ml-8 mt-4 bg-indigo-900 rounded-lg p-4">
            <div className="">
              <div className="flex items-center">
                <Avatar
                  src={
                    session?.user.image ||
                    "https://docs.material-tailwind.com/img/face-2.jpg"
                  }
                  referrerPolicy="no-referrer"
                  alt={`${session?.user.name}'s avatar`}
                />

                <div className="ml-3 mr-3">
                  <motion.div
                    className="text-base font-medium leading-none text-white text-right"
                    initial={{ y: -30 }}
                    animate={{ y: 0 }}
                    transition={{
                      type: "spring",
                      stiffness: 260,
                      damping: 20,
                    }}
                  >
                    {session?.user.name}
                  </motion.div>
                  <motion.div
                    className="text-sm font-medium leading-none text-gray-400 text-right"
                    initial={{ y: -30 }}
                    animate={{ y: 0 }}
                    transition={{
                      type: "spring",
                      stiffness: 260,
                      damping: 20,
                    }}
                  >
                    {session?.user.email}
                  </motion.div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-[70%] mt-8 ml-8">{renderSessionInfo()}</div>
          <div className="w-[70%] ml-8">
            <p className="text-xs text-slate-500">API v{apiVersion}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Hamburger;
